import React from "react";
//import PropTypes from 'prop-types';

import Form from "containers/Form";
import Field from "containers/Field";
import { EntryDescription } from "playground/cms/views/Entries";
import ExtendedFields from "playground/cms/fields/ExtendedFields";
import { FormLayout } from "playground/cms/Form";
import Address from "playground/cms/fields/Address";
import { Property, PropertyGrid } from "playground/cms/fields/Properties";
import DatePicker from "playground/cms/fields/DatePicker";
import { MediaField } from "playground/cms/fields/Media";

const selectFields = {
    title: false,
    slug: false,
    layout: false,
    seo: false,
    open_graph: false,
    translations: false,
    tags: false,
    type: false,
    headline: false,
    text: false,
    media: false,
};

export function ProjectsForm(props) {
    const { type, id } = props;
    return (
        <div className={"pad-md rows gap-md"}>
            <EntryDescription {...props} />
            <Field id={"short_name"} label={"Nazwa skrócona"} />
            <Field id={"address"} label={"Adres"} FieldComponent={Address} />
            <PropertyGrid>
                <Property label={"Kontakt"}>
                    <Field
                        id={"contact"}
                        fieldType={"select"}
                        source={"api:cms.entries.contacts"}
                        variant={"inline"}
                        label={"Przypisz osobę"}
                        nullable={true}
                    />
                </Property>
                <Property label={"Strona"}>
                    <Field label={null} id={"website_url"} variant={"dense"} />
                </Property>
                <Property label={"Data"}>
                    <Field
                        id={"date"}
                        FieldComponent={DatePicker}
                        label={"Wybierz datę"}
                        nullable={true}
                        className={"cols gap-xs"}
                    />
                </Property>
            </PropertyGrid>

            <MediaField id={"logo"} label={"Logo"} />
            <MediaField id={"reference"} label={"Referencje"} />

            <FormLayout.Section name={"Custom fields"} variant={"default"}>
                <ExtendedFields {...props} />
                {/*<Form type={type} id={id} selectFields={selectFields} />*/}
            </FormLayout.Section>
            {/*<Form type={type} id={id} selectFields={selectFields} />*/}
        </div>
    );
}

ProjectsForm.propTypes = {};

ProjectsForm.defaultProps = {};

export default ProjectsForm;
